"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable prettier/prettier */
const react_1 = __importDefault(require("react"));
const breadcrumb_1 = __importDefault(require("../../breadcrumb"));
const Header3Breadcrumb = (props) => {
    const { breadcrumb } = props;
    if (breadcrumb) {
        return (react_1.default.createElement("div", { className: "header3-breadcrumb" },
            react_1.default.createElement(breadcrumb_1.default, { breadcrumb: breadcrumb })));
    }
    return null;
};
exports.default = Header3Breadcrumb;
//# sourceMappingURL=index.js.map